"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessages = void 0;
const react_1 = require("react");
const footerContext_1 = __importDefault(require("./footerContext"));
const footerReducer_1 = require("./footerReducer");
const useMessages = () => {
    const { state, dispatch } = (0, react_1.useContext)(footerContext_1.default);
    const setMessages = (messages) => {
        dispatch({ type: footerReducer_1.ActionTypes.SET_MESSAGES, value: messages });
    };
    return (0, react_1.useMemo)(() => {
        return {
            messages: state.messages,
            setMessages,
        };
    }, [state.messages]);
};
exports.useMessages = useMessages;
//# sourceMappingURL=messages.hooks.js.map